import { Box, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface LoadingSpinnerProps {
  message?: string;
}

export default function LoadingSpinner({ message }: LoadingSpinnerProps = {}) {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        flexGrow: 1,
        minHeight: '100vh',
      }}
    >
      <CircularProgress />
      <Typography variant="subtitle1">{message || t('loading')}</Typography>
    </Box>
  );
}
